import React, { useState, useEffect, useContext } from 'react'
import './OrganiserReport.css'
import { DataGridComponent } from "../../Components/PaginationComponent";
import APIServices from '../../services/APIServices';
import { EnvironmentContext } from '../../EnvironmentContext';
import apiconfig from '../../config/config';
import { useSelector } from 'react-redux';
import { Backdrop, CircularProgress } from '@mui/material';
import { setAccessToken } from '../../Redux/Actions';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
const OrganiserReport = () => {
    const { environment } = useContext(EnvironmentContext);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [EventsData, setEventsData] = useState([]);
    const [allOrganisersRatings, setAllOrganisersRating] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const allUsers = useSelector(state => state.allUserDetails)
    const getAllValidUsers = allUsers.filter((eachUser) => eachUser.valid_mail === true);
    const accessToken = useSelector((state) => state.accessToken);
    const usersDataMetrics = useSelector((state) => state.usersMetricsData);
    const organisersDataMetrics = useSelector((state) => state.organisersMetricsData);

    const getAllOrganisers = () => {
        const allOrganisers = allUsers.filter((eachUser) => eachUser?.user_type === 'organiser')
        return allOrganisers
    }

    const getAllOrganisersEnagageCount = () => {
        const totalOrganisersEngage = getAllOrganisers().filter((eachOrganiser) => eachOrganiser?.my_organized_trips && eachOrganiser?.my_organized_trips !== 0)
        return totalOrganisersEngage
    }

    const OrganiserParticipationRate = () => {
        const totalParticipantRate = getAllOrganisersEnagageCount().length / EventsData.length * 100
        return totalParticipantRate.toFixed(2);
    }

    const getOrganiserRating = (organiser) => {
        if (organiser?.user_type === 'organiser') {
            return organiser?.organiser_rating
        } else {
            return "NA"
        }
    }

    useEffect(() => {
        const tokenLocal = JSON.parse(localStorage.getItem("token"));
        if (!accessToken && tokenLocal) {
            dispatch(setAccessToken(tokenLocal));
            APIServices.setAuthToken(tokenLocal);
        } else if (!accessToken && !tokenLocal) {
            navigate("/login");
        }

        if (accessToken || tokenLocal) {
            const tokenToUse = accessToken || tokenLocal;
            setIsLoading(true);
            APIServices.setAuthToken(tokenToUse);
            const url = environment === "Production"
                ? apiconfig.production.apiBaseUrl
                : apiconfig.develpoment.apiBaseUrl;

            APIServices.setApiBaseUrl(url);
            APIServices.getAllEvents()
                .then((response) => {
                    setIsLoading(false);
                    setEventsData(response.data.Events)
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log("Error While Fetching All Events: ", err);
                });
            APIServices.getAllOrganisersRatings()
                .then((response) => {
                    setIsLoading(false);
                    setAllOrganisersRating(response?.data?.Feedbacks)
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log("Error While Fetching All Organisers Ratings: ", err);
                });
        }
    }, [environment, accessToken, navigate, dispatch]);
    console.log(allOrganisersRatings)
    const columns = [
        {
            field: "ProfileID",
            headerName: "Profile ID",
            width: 150,
            headerClassName: "custom-header",
            renderCell: (params) => <span style={{ color: '#0B63F8' }}>{params.value}</span>
        },
        {
            field: "Country",
            headerName: "Country",
            width: 150,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
            renderCell: (params) => <span style={{ color: '#0B63F8' }}>{params.value}</span>
        },
        {
            field: "Full_Name",
            headerName: "Full Name",
            width: 150,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "Tripsattended",
            headerName: "Trips attended",
            width: 150,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "Totaltripsorganised",
            headerName: "Total trips organised",
            width: 200,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "Lastactive",
            headerName: "Last active",
            width: 200,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "Organiserrating",
            headerName: "Organiser rating",
            width: 200,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
    ];

    console.log("allUsers: ", allUsers[0])

    const rows = getAllValidUsers?.map((item) => ({
        id: item?._id,
        _id: item?._id,
        ProfileID: item.profile_id,
        Country: item?.country,
        Full_Name: `${item?.firstName} ${item?.lastName}`,
        Tripsattended: item?.my_events?.length || 0,
        Totaltripsorganised: item?.user_type === 'organiser' ? (item?.my_organized_trips?.length || 0) : 'NA',
        Lastactive: "NA",
        Organiserrating: getOrganiserRating(item),
        event_object_id: item?._id,
    }));

    const mostTripsAttendedByTheUser = rows
        .sort((a, b) => b.Tripsattended - a.Tripsattended)
        .slice(0, 10);

    const mostTripsOrganisedByTheOrganiser = rows
        .sort((a, b) => b.Totaltripsorganised - a.Totaltripsorganised)
        .slice(0, 10);

    return (
        <>
            <Backdrop
                sx={{
                    color: "#ffffff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <div>

                <div className="event-information-container">
                    <div className="details-container">
                        <div className="details-content-container-organiser">
                            <h5 className="information-side-heading">Total users</h5>
                            <p className="information-content">{usersDataMetrics?.totalUsers}</p>
                        </div>
                        <div className="details-content-container-organiser">
                            <h5 className="information-side-heading">Total users engaged</h5>
                            <p className="information-content">{usersDataMetrics?.totalEngagedUsers}</p>
                        </div>
                        <div className="details-content-container-organiser">
                            <h5 className="information-side-heading">Total Active users</h5>
                            <p className="information-content">NA</p>
                        </div>
                        <div className="details-content-container-organiser">
                            <h5 className="information-side-heading">Event participation rate</h5>
                            <p className="information-content">
                                {usersDataMetrics?.eventParticipationRate}%
                            </p>
                        </div>
                    </div>
                    <div className="details-container">
                        <div className="details-content-container-organiser">
                            <h5 className="information-side-heading">Total Organisers</h5>
                            <p className="information-content">{organisersDataMetrics?.totalOrganizers}</p>
                        </div>
                        <div className="details-content-container-organiser">
                            <h5 className="information-side-heading">Overall organisers rating</h5>
                            <p className="information-content">NA</p>
                        </div>
                        <div className="details-content-container-organiser">
                            <h5 className="information-side-heading">Total organisers engaged</h5>
                            <p className="information-content">{organisersDataMetrics?.totalEngagedOrganizers}</p>
                        </div>
                        <div className="details-content-container-organiser">
                            <h5 className="information-side-heading">Total Active Organisers</h5>
                            <p className="information-content">
                                NA
                            </p>
                        </div>
                        <div className="details-content-container-organiser">
                            <h5 className="information-side-heading">Organiser participation rate</h5>
                            <p className="information-content">
                                {OrganiserParticipationRate()}%
                            </p>
                        </div>
                    </div>
                </div>
                <br></br>
                <p className='top10'>Top 10</p>
                <div className="event-information-container-2">
                    <div class="section">
                        <div className='headings'>
                            <div className='list-users-container'>
                                <p className='list-users'>List of users joined maximum trips</p>
                            </div>
                        </div>
                        {mostTripsAttendedByTheUser.map((user, index) => (
                            <div className="details-content-container-organiser" key={user.id}>
                                <h5 className="information-side-no">{index + 1}</h5>
                                <h5 className="side-heading">{user.Full_Name}</h5>
                                <p className="information-content1">{user.Tripsattended}</p>
                            </div>
                        ))}
                    </div>

                    <div class="section">
                        <div className='headings'>
                            <div className='list-users-container'>
                                <p className='list-users'>List of users organised maximum trips</p>
                            </div>
                        </div>
                        {mostTripsOrganisedByTheOrganiser.map((user, index) => (
                            <div className="details-content-container-organiser" key={user.id}>
                                <h5 className="information-side-no">{index + 1}</h5>
                                <h5 className="side-heading">{user.Full_Name}</h5>
                                <p className="information-content1">{user.Totaltripsorganised}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div style={{ marginTop: '50px' }}>
                    <DataGridComponent columns={columns} rows={rows} />
                </div>
                <br></br>
                <div className='Total-count'>
                    <p className='Amount'>Total users </p>
                    <p className='Total-Rup'>{getAllValidUsers.length}</p>
                </div>
            </div>
        </>
    )
}

export default OrganiserReport
